define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/breadcrumb/NewController",
	"csi/sessionConstants",
	"./NewSupplierRequestMixin",
	"Apparel/DesignatedSupplierMixin"
], function(declare,lang,NewController,sessionConstants,NewSupplierRequestMixin,DesignatedSupplierMixin) {

	return declare([NewController,NewSupplierRequestMixin,DesignatedSupplierMixin], {
		productField: null,

		bNavigate: false,

		_canRepeat: function() {
			// summary: allow Save & New in this case
			return true;
		},

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set the product and the default value for BOM on create form
			this.inherited(arguments);

			const parent = this.getParent();
			if (parent) {
				var parentType = parent.$Type;
				this.productField = parentType + "s";
				view.addFixedValue(this.productField, [parent.$URL]); // Style or Material
				view.addFixedValue("RequestType", "DataPackageContainerType:" + parentType);
			}

			//initialize designated supplier
			this.initializeDPS(view, "SRSuppliers");
			view.addDefaultValue("Requester", sessionConstants.userUrl);
		}
	});
});
